import type { FC } from "react";

import type { IShareBarProps } from "@similarweb/ui-components";
import { ShareBar } from "@similarweb/ui-components";

import { StyledProgressBarCellWrapper } from "./styles";

type ProgressBarCellProps = IShareBarProps & {
    barWidth?: number;
    barHeight?: number;
};

const ProgressBarCell: FC<ProgressBarCellProps> = (props) => {
    const { barWidth, barHeight, ...other } = props;

    return (
        <StyledProgressBarCellWrapper
            barHeight={barHeight}
            barWidth={barWidth}
        >
            <ShareBar {...other} />
        </StyledProgressBarCellWrapper>
    );
};

export default ProgressBarCell;
